import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const TERMS_PREVIEW_LENGTH = 100;

/**
 * Couple-facing terms preview: first 100 characters plus modal for the full text.
 */
export function AgreementTermsViewer({ termsText }) {
  const [modalOpen, setModalOpen] = useState(false);
  const trimmed = (termsText || '').trim();

  if (!trimmed) return null;

  const isTruncated = trimmed.length > TERMS_PREVIEW_LENGTH;
  const preview = isTruncated
    ? `${trimmed.slice(0, TERMS_PREVIEW_LENGTH)}…`
    : trimmed;

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>
        Terms & conditions
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ whiteSpace: 'pre-wrap', mb: 1.5 }}
      >
        {preview}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Button variant="outlined" size="small" onClick={() => setModalOpen(true)}>
          View full terms & conditions
        </Button>
      </Box>

      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>Terms & conditions</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
            {trimmed}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AgreementTermsViewer;
